import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { GoogleAuthInterceptor } from '@googleDriveAuthConfig/interceptors/google-auth.interceptor';
import { NbButtonModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { AuthModule, LogLevel } from 'angular-auth-oidc-client';
import { environment as env } from '@env';
import { GoogleAuthButtonComponent } from './components/google-auth-button/google-auth-button.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [ GoogleAuthButtonComponent ],
  exports: [ GoogleAuthButtonComponent ],
  imports: [
    SharedModule,
    CommonModule,
    HttpClientModule,
    NbButtonModule,
    TranslateModule,
    AuthModule.forRoot({
      config: {
        authority: 'https://accounts.google.com',
        redirectUrl: `${env.baseUrl}myFiles`,
        postLogoutRedirectUri: window.location.origin,
        triggerAuthorizationResultEvent: true,
        clientId: env.googleDriveAuth.clientId,
        scope: env.googleDriveAuth.scope,
        responseType: 'id_token token',
        useRefreshToken: true,
        // renewTimeBeforeTokenExpiresInSeconds: 10,
        logLevel: env.production ? LogLevel.None : LogLevel.Debug,
        secureRoutes: env.googleDriveAuth.secureRoutes
      },
    })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: GoogleAuthInterceptor, multi: true },
  ],
})
export class GoogleModule { }
